import * as Types from './actionTypes';

const initialState = {
  drivers: [],
  shipments: [],
  shippers: [],
  driverDocs: {
    isLoading: true,
    data: [],
    id: null,
  },
};

const reducer = function (state = initialState, action) {
  const { type, payload } = action;
  switch (type) {
    case Types.INIT_DRIVERS: {
      return {
        ...state,
        drivers: payload.drivers,
      };
    }
    case Types.INIT_SHIPPERS: {
      return {
        ...state,
        shippers: payload.shippers,
      };
    }
    case Types.INIT_SHIPMENTS: {
      return {
        ...state,
        shipments: payload.shipments,
      };
    }
    case Types.FETCH_DRIVER_DOCS:
      return {
        ...state,
        driverDocs: {
          ...state.driverDocs,
          data: [],
          id: action.payload.id,
          isLoading: true,
        },
      };

    case Types.DRIVER_DOCS_FETCHED:
      return {
        ...state,
        driverDocs: {
          ...state.driverDocs,
          data: action.payload.data,
          isLoading: false,
        },
      };

    case Types.APPROVE_DRIVER_DOC:
      return {
        ...state,
        driverDocs: {
          ...state.driverDocs,
          data: state.driverDocs.data.map((doc) => {
            if (doc.fileLocation === action.payload.id) {
              return {
                ...doc,
                isApproving: true,
              };
            }
            return doc;
          }),
        },
      };
    case Types.DRIVER_DOC_APPROVED:
      return {
        ...state,
        driverDocs: {
          ...state.driverDocs,
          data: state.driverDocs.data.map((doc) => {
            if (doc.fileLocation === action.payload.doc.fileLocation) {
              return {
                ...doc,
                ...action.payload.doc,
                isApproving: false,
              };
            }
            return doc;
          }),
        },
      };

    case Types.REJECT_DRIVER_DOC:
      return {
        ...state,
        driverDocs: {
          ...state.driverDocs,
          data: state.driverDocs.data.map((doc) => {
            if (doc.fileLocation === action.payload.id) {
              return {
                ...doc,
                isApproving: false,
                isRejecting: true,
              };
            }
            return doc;
          }),
        },
      };
    case Types.DRIVER_DOC_REJECTED:
      return {
        ...state,
        driverDocs: {
          ...state.driverDocs,
          data: state.driverDocs.data.map((doc) => {
            if (doc.fileLocation === action.payload.doc.fileLocation) {
              return {
                ...doc,
                ...action.payload.doc,
                isApproving: false,
                isRejecting: false,
              };
            }
            return doc;
          }),
        },
      };

    default:
      return state;
  }
};

export default reducer;
